import Alert from '@mui/material/Alert'
import { Toaster, ToastBar, toast } from '@redwoodjs/web/toast'
import { keyframes } from 'goober'

const mapToastTypeToAlertSeverity = {
  success: 'success',
  error: 'error',
  loading: 'info',
  blank: 'info',
}

const fadeInAnimation = `0%{opacity:0;} 100%{opacity:1;}`
const fadeOutAnimation = `0%{opacity:1;} 100%{opacity:0;}`

const CustomToaster = () => (
  <Toaster
    position="bottom-center"
    containerStyle={{
      bottom: 56 + 16,
      inset: '72px 8px',
    }}
    toastOptions={{
      style: {
        padding: 0,
        margin: 0,
        width: '100%',
        maxWidth: '100%',
      },
    }}
  >
    {(t) => (
      <ToastBar
        toast={t}
        style={{
          ...t.style,
          animation: t.visible
            ? `${keyframes(
                fadeInAnimation
              )} 0.35s cubic-bezier(.21,1.02,.73,1) forwards`
            : `${keyframes(
                fadeOutAnimation
              )} 0.4s forwards cubic-bezier(.06,.71,.55,1)`,
        }}
      >
        {({ message }) => (
          <Alert
            icon={false}
            variant="filled"
            severity={mapToastTypeToAlertSeverity[t.type]}
            onClose={() => toast.dismiss(t.id)}
            sx={{
              width: '100%',
            }}
          >
            {message}
          </Alert>
        )}
      </ToastBar>
    )}
  </Toaster>
)

export default CustomToaster
